import React from 'react'
import RidingResult from '../../../models/RidingResult'
import PartyLozenge from '../../Helpers/PartyLozenge'

import './MapTooltip.scss'
import PartyResult from '../../../models/PartyResult'
import U from '../../../utils/Utilities'
import { resultForKey } from '../../../controllers/DataController'

interface IProps {
  result: RidingResult
  baseResultKey: string
}

const MapTooltip: React.StatelessComponent<IProps> = (
  props: IProps
): JSX.Element => {
  const { result, baseResultKey } = props
  const result2015 = resultForKey(baseResultKey).resultForRiding(
    +result.riding.key
  )

  const voteResults = result.partyResultMap.resultsByVotePercent()
  const voteRows = voteResults.map(
    (partyResult: PartyResult): JSX.Element => {
      const party = partyResult.party
      const partyResult2015 = result2015.partyResultByParty(party)

      const winner2015 =
        partyResult2015 && partyResult2015.outcome === 'majority'
      const winnerNow = partyResult.outcome === 'majority'
      return (
        <tr key={party.key}>
          <td style={{ color: party.rgbColor }} className="font-weight-bold">
            <span className="d-sm-none">{party.code}</span>
            <span className="d-none d-sm-inline">{party.shortName}</span>
          </td>

          <td className={`text-right text-muted ${U.boldIf(winner2015)}`}>
            {partyResult2015 ? (
              U.formatPercent(partyResult2015.votePercent)
            ) : (
              <React.Fragment>&mdash;</React.Fragment>
            )}
          </td>
          <td className={`text-right ${U.boldIf(winnerNow)}`}>
            {U.formatPercent(partyResult.votePercent)}
          </td>
          <td className="text-right">
            {partyResult2015 ? (
              U.formatPercentDiff(
                partyResult2015.votePercent,
                partyResult.votePercent
              )
            ) : (
              <React.Fragment>&mdash;</React.Fragment>
            )}
          </td>
        </tr>
      )
    }
  )
  return (
    <div className="MapTooltip">
      <div className="MapTooltip-Header">
        <h2 className="text-muted">{result.riding.province.name()}</h2>
        <h1>{result.riding.name()}</h1>
        <div className="row no-gutters d-flex align-items-baseline">
          <div className="col-12 col-sm-8">
            <PartyLozenge party={result.winner().party} darkBg />
            <span className="MapTooltip-MOV">
              <span className="mov font-weight-bold">
                +{U.formatPercent(result.margin())}
              </span>{' '}
              over&nbsp;&nbsp;
              <PartyLozenge
                darkBg
                // muted
                small
                party={result.nthPlace(2).party}
              />
            </span>
          </div>
          <div className="col-12 col-sm-4 text-sm-right mt-1 mt-sm-0">
            {result.winner().party.key === result2015.winner().party.key ? (
              <b>Hold</b>
            ) : (
              <span>
                <b>Gain</b> from&nbsp;&nbsp;
                <PartyLozenge
                  darkBg
                  // muted
                  small
                  party={result2015.winner().party}
                />
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="MapTooltip-Table">
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Party</th>
              <th className="text-right">
                <span className="d-sm-none">
                  2015
                  <br />
                  Vote %
                </span>
                <span className="d-none d-sm-inline">Prev.</span>
              </th>
              <th className="text-right">
                <span className="d-sm-none">
                  Est
                  <br />
                  Vote %
                </span>
                <span className="d-none d-sm-inline">Curr.</span>
              </th>
              <th className="text-right">Change</th>
            </tr>
          </thead>
          <tbody>{voteRows}</tbody>
        </table>
      </div>
    </div>
  )
}

export default MapTooltip
